(() => {
  const dialog = document.getElementById('orayta-welcome');
  if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;
  const key = 'orayta_welcome_10_v1';
  const now = Date.now();
  const subscribed = dialog.dataset.subscribed === 'true';
  const returnedFromSignup = new URLSearchParams(location.search).get('customer_posted') === 'true';
  const preview = new URLSearchParams(window.location.search).get('welcome_preview') === '1';
  const success = !!dialog.querySelector('[data-welcome-success]');
  const error = !!dialog.querySelector('[role="alert"]');
  let saved;
  try { saved = JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { saved = null; }

  function open() {
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-welcome-close]')?.focus({ preventScroll: true });
  }
  function decline() {
    try { localStorage.setItem(key, JSON.stringify({ until: now + 7 * 86400000 })); } catch (_) {}
    dialog.close();
  }

  dialog.querySelector('[data-welcome-decline]')?.addEventListener('click', decline);
  dialog.querySelector('[data-welcome-close]')?.addEventListener('click', decline);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); decline(); });
  if (subscribed && !preview && !returnedFromSignup && dialog.querySelector('[data-welcome-success]')?.dataset.posted !== 'true') return;
  if (success) {
    try { localStorage.setItem(key, JSON.stringify({ until: now + 10 * 365 * 86400000 })); } catch (_) {}
    open();
  } else if (preview || error || !saved || saved.until < now) {
    window.setTimeout(open, error || preview ? 0 : 6000);
  }
})();
